import DisableChapterIcon from '@mui/icons-material/Close';
import React from 'react';

import { ReactComponent as AudioIconSVG } from '../../../assets/img/icons/audio.svg';

function AudioBadge({
  progress,
  onClick,
  onRestart,
  hasAudioSummary,
  hasPlaylist,
}) {
  let safeProgress = 0;
  if (progress && typeof progress === 'number') {
    safeProgress = Math.min(100, Math.max(0, progress));
  }

  // Determine the CSS class based on audio types
  let audioClass = '';
  if (hasPlaylist && hasAudioSummary) {
    audioClass = 'has-both-audio';
  } else if (hasAudioSummary) {
    audioClass = 'has-audio-summary-only';
  } else if (hasPlaylist) {
    audioClass = 'has-playlist-only';
  }

  return (
    <div className="audio-badge-container">
      <div
        onClick={onClick}
        className={`audio-progress-outer ${audioClass}`}
        style={{ '--progress': `${safeProgress}%` }}
      >
        <div className="audio-progress-inner">
          <AudioIconSVG className="audio" />
        </div>
      </div>
      {progress > 0 && (
        <button
          className="audio-restart-btn"
          onClick={(e) => {
            e.stopPropagation();
            onRestart();
          }}
          title="Restart audio playlist"
        >
          <DisableChapterIcon
            fontSize="small"
            style={{
              fontSize: '12px',
              color: 'white',
            }}
          />
        </button>
      )}
    </div>
  );
}

export default AudioBadge;
